import React, { Fragment, Component } from 'react';
import Question from '../MultipleChoice/Question';
import Feedback from '../Feedback';
import PagerButton from '../PagerButton';
import Button from '../Button';

class PersonalityQuiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFeedbackReady: false,
      displayFeedback: false
    };
  }

  componentDidMount = () => {
    const { input, data } = this.props;
    if (input && Object.keys(input).length === data.questions.length) {
      this.setState({
        displayFeedback: true,
        answerTracking: []
      });
    }
  };

  handleClick = (question, option) => {
    const { input, onInput, data, onCompletion } = this.props;
    const { displayFeedback } = this.state;

    const payload = {
      ...input,
      [question]: option
    };
    if (Object.keys(payload).length === data.questions.length) {
      onCompletion();
      this.setState({
        isFeedbackReady: true
      });
    }
    if (!displayFeedback) {
      onInput(payload);
    }
  };

  determineFeedbackType = () => {
    const { input, data, feedback } = this.props;
    let answerIndex = feedback.length - 1;
    let answerTally = [];

    data.questions.forEach(question => {
      // input[question.question] gives us the user-selected answer
      question.options.forEach((option, optionIndex) => {
        if (input[question.question] === option.label) {
          // if the questions match, work through options and compare answer with options
          // Once we find the correct answer, we:
          if (answerTally[optionIndex]) {
            // increment the number of attempts this answer has been picked
            answerTally[optionIndex] = answerTally[optionIndex] + 1;
          } else {
            // populate the array with one for this answer
            answerTally[optionIndex] = 1;
          }
        }
      });
    });

    answerTally.forEach((answer, index) => {
      // If any of the answers are greater than the answerThreshold, that index is the feedback we display.
      if (answer >= data.answerThreshold) {
        answerIndex = index;
      }
    });

    return {
      feedbackType: 'success',
      title: feedback[answerIndex].title,
      body: feedback[answerIndex].body
    };
  };

  getSelectedOption = question => {
    const { input } = this.props;
    if (input && question in input) {
      return input[question];
    }
    return null;
  };

  submitAnswers = () => {
    this.setState({
      displayFeedback: true
    });
  };

  renderQuestion = (data, i) => {
    return (
      <Question
        key={i}
        data={data}
        onClick={this.handleClick}
        input={this.getSelectedOption(data.question)}
      />
    );
  };

  render() {
    const { data } = this.props;
    const { isFeedbackReady, displayFeedback } = this.state;

    return (
      <Fragment>
        {data.questions.map((question, i) => {
          question.inputType = 'radio';
          return this.renderQuestion(question, i);
        })}
        {displayFeedback && (
          <div>
            <Feedback {...this.determineFeedbackType()}>
              <PagerButton />
            </Feedback>
          </div>
        )}
        {!displayFeedback && (
          <div className="validation-submit-button-wrapper">
            <Button
              disabled={isFeedbackReady === false}
              onClick={this.submitAnswers}
            >
              Submit
            </Button>
          </div>
        )}
      </Fragment>
    );
  }
}

export default PersonalityQuiz;



// WEBPACK FOOTER //
// ../core/src/components/PersonalityQuiz/PersonalityQuiz.js